import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchSampleType = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.SAMPLETYPE.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const createSampleType = (payload) => {
  return axiosInstance.post(EndPoints.SAMPLETYPE.CREATE, payload);
};

export const updateSampleType = (payload) => {
  return axiosInstance.put(EndPoints.SAMPLETYPE.UPDATE, payload);
};

export const fetchSampleTypeVoilImage = (
  // page_no,
  sample_type_id
  // filter,
  // limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.SAMPLETYPE.GET_VOIL_IMAGE, {
    params: {
      // limit,
      // page_no,
      // zone_id,
      // ...filter,
      sample_type_id: sample_type_id,
    },
  });
};

export const uploadVoilImageSampleType = (payload) => {
  return axiosInstance.post(EndPoints.SAMPLETYPE.UPLOAD_VOIL_IMAGE, payload);
};

export const deleteSampleType = (payload) => {
  const url = EndPoints.SAMPLETYPE.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.SAMPLETYPE.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
